import { useShortIdContext } from '@air/provider-short-id';

import { usePublicBoardStats } from '~/components/v2/hooks/queries/usePublicBoardsStats';
import { useViewsSelectAllStore } from '~/components/v2/store/features/views/useViewsSelectAllStore';
import { useIsFlattenedView } from '~/hooks/search/useIsFlattenedView';
import { useURLBoardIdSelector } from '~/hooks/useURLBoardIdSelector';

export const usePublicSelectAllTotalCount = () => {
  const { shortId } = useShortIdContext();
  const currentBoardId = useURLBoardIdSelector();
  const selectAll = useViewsSelectAllStore((state) => state.selectAll);
  const includeNestedItems = useViewsSelectAllStore((state) => state.includeNestedItems);
  const selectAllRootBoardId = useViewsSelectAllStore((state) => state.selectAllRootBoardId);
  const { isFlattenedView } = useIsFlattenedView();

  const boardId = selectAll ? selectAllRootBoardId : currentBoardId;
  const includeDescendants = selectAll ? includeNestedItems || isFlattenedView : isFlattenedView;

  const { data: stats } = usePublicBoardStats(
    {
      boardId,
      shortId,
      includeDescendants,
    },
    { keepPreviousData: true },
  );

  return stats ? (stats.assetCount ?? 0) + (stats.fileCount ?? 0) : undefined;
};
